/**
 * Les colonnes du live du masteur (pur) : les seuils qui les ancrent et leurs largeurs. Lues par le live
 * (`<TutorLivePage>`) et par « Mes élèves » dans le cadre du live (`<TutorStudentsDeskPage>`), pour que les deux
 * gardent le même cadre quand l'un change.
 */

/** À partir de cette largeur de page, la colonne du champion est ancrée (en dessous, un tiroir). */
export const FEED_ANCHORED_FROM = 1024
/** À partir de cette largeur, la pellicule et la colonne du champion prennent leur largeur pleine. */
export const TUTOR_LIVE_WIDE_FROM = 1200
/** La pellicule, large puis resserrée. */
export const FILMSTRIP_WIDTH = { wide: 232, narrow: 208 }
/**
 * La colonne du champion, à largeur fixe (Wajih, 04/11 : « ni l'agrandir ni la rétrécir ») : 380 au large, comme
 * les maquettes ; 320 de 1 024 à 1 200, où le centre n'aurait plus la place de l'activité.
 */
export const FEED_WIDTH = { wide: 380, narrow: 320 }

/**
 * Le bouton qui replie et déplie une colonne : la page le pose, à la MÊME place repliée et dépliée (Wajih, 05/11 :
 * « l'icône reste exactement au même endroit »), dans le coin haut extérieur de la colonne. À l'horizontale, il est
 * centré dans la colonne repliée (40 à gauche, 80 à droite, `RAIL_WIDTH`) ; à la verticale, sur la ligne de l'en-tête
 * de la colonne dépliée (« Élèves · n » à gauche, « À traiter » et sa ligne d'aide à droite, plus haute).
 */
export const COLUMN_TOGGLE = {
    size: 32,
    iconSize: 18,
    top: { left: 12, right: 18 },
    inset: { left: 4, right: 24 },
} as const

/** L'écart entre le bouton de repli et l'en-tête qu'il borde. */
const TOGGLE_GAP = 4

/**
 * La place que garde l'en-tête d'une colonne dépliée, de son bord extérieur, pour le bouton que la page pose dessus :
 * `padding` est le retrait de la colonne de ce côté.
 */
export function columnToggleRoom(side: "left" | "right", padding: number): number {
    return COLUMN_TOGGLE.inset[side] + COLUMN_TOGGLE.size + TOGGLE_GAP - padding
}
